(function (ng) {
    

    angular.module('windowExt', []);
})(angular);
